<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard>
          <form id="createCategory" @submit="createCategory" >
          <CCardHeader>
            <CCol col="6" style="font-size: 25px;">إضافة فئة جديدة</CCol>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="6">
                <CInput label="Name"
                  id="name"
                  v-model="category.name"
                  class="required"
                  placeholder=" أدخل إسم التصنيف بالانجليزية"
                  :invalidFeedback="errors.name"
                  required
                />
              </CCol>
              <CCol sm="6">
                <CInput label="الاسم"
                  id="name"
                  v-model="category.name_ar"
                  class="required"
                  placeholder="أدخل إسم التصنيف بالعربي"
                  :invalidFeedback="errors.name_ar"
                  required
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CTextarea
                  label='الوصف (اختياري)'
                  placeholder='المحتوى  بالإنجليزية'
                  horizontal
                  rows='4'
                  v-model='category.description'
                  :invalidFeedback="errors.description"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CTextarea
                  label='الوصف (اختياري)'
                  placeholder='المحتوى بالعربي'
                  horizontal
                  rows='4'
                  v-model='category.description_ar'
                  :invalidFeedback="errors.description_ar"
                />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter>
            <CButton type="submit" size="sm" color="primary" ><CIcon name="cil-check-circle"/> حفظ</CButton>
              &emsp;
            <CButton type="reset" size="sm" color="danger"><CIcon name="cil-ban"/> مسح </CButton>
          </CCardFooter>
          </form>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: 'CreateCategory',
  data: function () {
    return {
      category: {},
      errors: []
    }
  },
  methods: {
    async createCategory (e) {
      e.preventDefault()
      const formData = new FormData()
      formData.append('name', this.category.name)
      formData.append('name_ar', this.category.name_ar)
      if (this.category.description) {
        formData.append('description', this.category.description)
      }
      if (this.category.description_ar) {
        formData.append('description_ar', this.category.description_ar)
      }
      this.errors = await this.postRequest(formData, this.$hostUrl + 'categories', '/categories')
    }
  }
}

</script>
